const $header = $('header');
$header.addClass('download-app-show');

const $widgetWrap = $('.download-app');
const $closeBtn = $widgetWrap.find('.close-link');
const dataSession = window.sessionStorage.getItem('mobile-bar-download-app');
const $main = $('main');

if (dataSession == 'true') {
  $header.removeClass('download-app-show');
  $widgetWrap.addClass('d-none');
} else {
  $widgetWrap.removeClass('d-none');
  window.sessionStorage.setItem('mobile-bar-download-app', 'false');
  $main.addClass('download-app-main');
}

$closeBtn.on('click', function (e) {
  e.preventDefault();
  $widgetWrap.addClass('d-none');
  $header.removeClass('download-app-show ');
  $main.removeClass('download-app-main');
  $('#inicio-conteudo').find('.rnk-componente-breadcrumb-custom').removeClass('app-bar');
  window.sessionStorage.setItem('mobile-bar-download-app', 'true');
});

export default {};
